export default "__VITE_ASSET__03ab634e__"